<template>
	<div class="common_table_page">
		<div class="top">
			<span class="title">{{ titleValue }}</span>
            <span v-if="description" class="desc">{{ description }}</span>
			<div>
				<tq-input 
					v-model="search" 
					class="input" 
					type="text"
					:maxlength="100"
					:placeholder="placeholder">
					<template #prefix>
						<img src="../../../assets/search.svg" alt="icon" class="input-icon">
					</template>
					<template #suffix>
						<img
							v-if="search"
							src="../../../assets/delete.svg" alt="icon"
							class="input-icon-delete"
							@click="deleteword">
						<span class="inputbutton" @click="() => fetchData({ pageNo: 1, pageSize: pageSize })">搜索</span>
					</template>
				</tq-input>
			</div>
		</div>
		<div class="table">
			<tq-list-view
				:total-records="total"
				:page-num="currentPage"
				:page-size="pageSize"
				hidden-search
				:init-load-data="true"
				:page-sizes="[10, 20, 30, 40, 50]"
				@query-list="fetchData">
				<template #table>
					<tq-table :data="tableData" :columns="columns" :loading="loading" />
				</template>
			</tq-list-view>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from "vue";
import { getMaterialTableData, getBioDrugsTableData, getBioDrugsIntermediatesTableData, getBioCatalyticEnzymesTableData } from "../../../apis/interfaces/tables";
import { ElMessage } from "element-plus";
interface ColumnConfig {
	prop: string;
	label: string;
}
const props = defineProps<{
	type: string;
	titleValue?: string;
	placeholder?: string;
	columns: ColumnConfig[];
	apiType: string;
}>();

interface TableItem {
	[key: string]: any;
}
const tableData = ref<TableItem[]>([]);
const currentPage = ref(1);
const pageSize = ref(10);
const total = ref(0);
const search = ref("");
const loading = ref(true);

onMounted(() => {
	fetchData({ pageNo: 1, pageSize: pageSize.value });
});

const deleteword = () => {
	search.value = "";
};

const fetchData = async (params: { pageNo: number; pageSize: number }) => {
	loading.value = true;
	try {
		let res
		let lastParams = {
			keyWord: search.value,
			pageNum: params.pageNo,
			pageSize: params.pageSize
		}
		if(props.type === 'bioDrug'){
			res = await getBioDrugsTableData (lastParams);
		} else if(props.type === 'bioDrugIntermediate'){
			res = await getBioDrugsIntermediatesTableData (lastParams);
		} else if(props.type === 'bioEnzyme'){
			res = await getBioCatalyticEnzymesTableData (lastParams);
		} else if(props.type === "ref" || props.type === "inter"){
			res = await getMaterialTableData({ type: props.apiType, ...lastParams });
		}
		
		if (res?.msgCode === "100") {
			const records = res?.responseData?.records || [];
			total.value = res?.responseData?.total || 0;
			
			if (records.length === 0) {
				tableData.value = [];
			} else {
				tableData.value = records
			}
		} else {
			ElMessage.error(res?.message || "获取数据失败");
		}
	} catch (error) {
		console.error("获取数据失败:", error);
		tableData.value = [];
		total.value = 0;
		ElMessage.error("获取数据失败，请稍后重试");
	} finally {
		loading.value = false;
	}
};

// 获取配置信息
import { useConfigStore } from "@/stores/index";
const store = useConfigStore()
const configData = computed(() => {
	console.log(store.configData,"store.configData")
	return store.configData
})
let description = ref("");
const key = `${props.apiType}_desc`;
let descList = configData.value?.[key] || [];
if(descList?.length > 0){
    description.value = descList?.join("") || "";
}
console.log(configData.value?.bioDrug_desc, descList, props.apiType, description.value,"configData.value")

</script>

<style lang="styl" scoped>
.common_table_page {
  width: 100%;
  min-height: calc(100% - 90px);
  background-color: #fff;
}
.common_table_page .top{
  display: flex;
  flex-direction: column;
  align-items: center; 
}
.common_table_page .title {
  height: 23px;
  font-weight: 500;
  font-size: 23px;
  color: #252525;
  line-height: 23px;
  margin-top: 65px;
}
.common_table_page .desc {
  font-size: 13px;
  color: #9d9d9d;
  line-height: 18px;
  margin-top: 25px;
  max-width: 80%;
}
.common_table_page .input {
  margin: 36px 0 35px 0;
  width: 35%;
  height: 50px;
  min-width: 600px;
}
.input-icon-delete { 
	margin-right: 10px;
	height: 12px;
}
.common_table_page .input .inputbutton{
  width: 29px;
  height: 15px;
  font-weight: 400;
  font-size: 15px;
  color: #0659A4;
  line-height: 15px;
  cursor: pointer;
}

.common_table_page .table {
  width: 70%;
  min-width: 1000px;
  margin: 0 auto;
  margin-bottom: 20px;
}
:deep(.el-table__empty-block) {
  height: 200px !important;
  min-height: 200px !important;
}
:deep(.el-table th) {
  background-color: #0659A4 !important;
  height: 49px;
}
:deep(.el-table__row td) {
  border: none !important;
}
:deep(.el-table__header-wrapper th) {
  border: none !important;
}
:deep(.el-table th.el-table__cell.tq-table-header) {
  color: #FFFFFF !important;
  font-weight: 500;
  font-size: 15px !important;
  line-height: 20px;
  font-style: normal;
}
:deep(.el-table) {
  font-size: 15px !important;
}
:deep(.el-table__row){
  border: 8px 0 !important;
}
:deep(.el-table .el-table__row) {
  height: 72px;
}
</style>